import React from 'react';
import { Box, Card, Grid2 as Grid, Link as MuiLink, Typography } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import CustomIcon from '../../../DesignSystem/CustomIcon';
import { Icons } from '../../../../Themes';
import { HtmlToMUIMapper } from '../../../../Utils';

function MetaInfo({ icon, label }: any) {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Box>{icon}</Box>
      <Typography color="textSecondary" variant="body2" sx={{ fontWeight: 'medium' }}>
        {label}
      </Typography>
    </Box>
  );
}

function SpaceInfoBox({ space, section, isMobile }: any) {
  if (!section.enabled) {
    return <Box sx={{ mt: isMobile ? 5 : 10 }} />;
  }

  return (
    <Card sx={{ padding: 3, textAlign: 'center' }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4" component="h1">
          {section.title}
        </Typography>
      </Box>

      {section.counters.users_and_participations_count && (
        <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
          <Grid>
            <MetaInfo
              label={
                <FormattedMessage
                  id="SPACE.HOME.SPACE_INFO.CITIZENS_COUNT"
                  values={{ count: space.users_count }}
                />
              }
              icon={<GroupIcon color="action" />}
            />
          </Grid>

          <Grid>
            <MetaInfo
              label={
                <FormattedMessage
                  id="SPACE.HOME.SPACE_INFO.IDEAS_COUNT"
                  values={{ count: space.participations_count }}
                />
              }
              icon={<CustomIcon src={Icons.misc.bulb} color="action" size={20} />}
            />
          </Grid>
        </Grid>
      )}

      <Box sx={{ mt: 1, mb: 2 }}>
        <HtmlToMUIMapper content={section.content} />
      </Box>

      <Typography>
        <MuiLink to={`/${space.slug}/about`} component={Link} underline="hover">
          <FormattedMessage id="BUTTONS.LEARN_MORE" />
        </MuiLink>
      </Typography>
    </Card>
  );
}

export default SpaceInfoBox;
